import { z } from 'zod';

export const VerificationOfMortgagePurpose = z.enum(['refinance', 'newLoanApplication', 'other']);
export type VerificationOfMortgagePurpose = z.infer<typeof VerificationOfMortgagePurpose>;

export const VERIFICATION_OF_MORTGAGE_DAYS = 4; // number of business days to generate the VOM. Used in the portal UI + task due date
